__turbopack_context__.v({
  "big": "ModalImageHeader-module__JdzHwG__big",
  "closeButton": "ModalImageHeader-module__JdzHwG__closeButton",
  "header": "ModalImageHeader-module__JdzHwG__header",
  "image": "ModalImageHeader-module__JdzHwG__image",
  "objectFitContain": "ModalImageHeader-module__JdzHwG__objectFitContain",
  "objectFitCover": "ModalImageHeader-module__JdzHwG__objectFitCover",
  "previousButton": "ModalImageHeader-module__JdzHwG__previousButton",
  "title": "ModalImageHeader-module__JdzHwG__title",
});
